import React from 'react'
import './Ourservicebanner.css'

function Ourservicebanner() {
  return (
    <div className='Ourservicebanner'>
      <div className='Ourservicebanner-heading'>
      <div className='ourservicebanner-para'>
      <div className='service-dot'></div> 
<p>Our Services</p>
      </div>

<h1>We combine our passion for design and code.</h1>
      </div>


      <div className="marqueethree">
  <div className="marquee__contentthree scrollThree">
   <h1>OUR SERVICES</h1>
   <h1 className='stroke-heading' >OUR SERVICES</h1>
  </div>
  <div className="marquee__contentthree scrollThree">
   <h1>OUR SERVICES</h1>
   <h1  className='stroke-heading'>OUR SERVICES</h1>
  </div>
</div>


    </div>
  )
}

export default Ourservicebanner
